import '../Rice/Rice.css';
import Sidebar from '../Sidebar/Sidebardigital';
import '../Sidebar/Sidebardigital'

function Rice() {
    return (
      <div className="row">
                <div className="col-2 custom-display">
          <Sidebar />
        </div>
        <div className="col-8 custom-width">
        <br/><p className= "rice-paragraph"><strong>Rice Traceability solution</strong> </p>
        <img src="https://www.ledgerinsights.com/wp-content/uploads/2019/11/rice-paddy-field-thailand-810x524.jpg" style={{width: '100%', height: 'auto'}} alt=" "/>
        <br/> <br/>
        <p><strong>Growers Benefits</strong></p>
        <ul className= "styled-list">
            <li>Market Access and Premium Pricing</li>
            <li>Builds Consumer Trust</li>
            <li>Compliance with Regulations</li>
            <li>Quality Improvement</li>
            <li>Reduction in Counterfeiting and Fraud</li>
        </ul>
        <br/> <br/>        <br/> <br/>
        <br/> <br/>


            </div>

              <div className="col-2 custom-display">
              <Sidebar />
            </div>
            </div>
    );
  }
  
  export default Rice;